@if (loading) {
  <ppl-loading
    [inverse]="inverse"
    [large]="large"
    [withLogo]="withLogo"></ppl-loading>
}
@if (text) {
  <span class="text">
    {{ text }}
  </span>
}
<div class="content">
  <ng-content></ng-content>
</div>
